import React from "react";
import { OnboardingNav } from "../Nav/BottomNav";
import { Link } from "react-router-dom";
import { PrimaryButton } from "../buttons";

export const Onboarding = ({ linkto, heading, body, imgurl, next }) => {
  return (
    <div className="container px-4 py-8 max-w-sm mx-auto relative h-[90vh] font-body flex flex-col">
      <div className="flex justify-between">
        <img className="w-32" src="/img/new/logo/logo.svg" />
        <Link to={linkto} className=" ml-auto ">
          Skip
        </Link>
      </div>

      <div>
        <img className="mt-4 rounded-lg" src={imgurl} />
      </div>

      <h3 className="text-2xl mt-4">{heading}</h3>
      <p className="font-light mt-3">{body}</p>

      <div className="flex justify-between bottom-4 absolute w-[92%] mx-auto">
        <OnboardingNav />
        <Link to={next} className="w-28">
          <PrimaryButton text="next" />
        </Link>
      </div>
    </div>
  );
};
